import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Button } from '@material-ui/core';
import t from "../../../languages/pl";
import CancelAcceptForm from "../../Common/CancelAcceptForm";
import ConfirmationDialog from '../../Common/ConfirmationDialog';

const useStyles = theme => ({
    row: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    textfield: {
        margin: theme.spacing(1),
        width: 240
    },
    requiredFields: {
        fontSize: 10,
        marginTop: theme.spacing(1),
        paddingLeft: theme.spacing(3.5),
        color: "red",
    },
});

const initialPricing = {
    nazwa: '',
    stawka_1_3dni: '',
    stawka_4_7dni: '',
    stawka_godzinna: '',
    stawka_pow_limit: '',
    stawka_tygodniowa: ''
};

const PricingDialog = props => {
    const { classes, open, singlePricing, onClose, onSubmit, onEdit, onPricingDelete, isEdit = false } = props;
    const [state, setState] = useState(initialPricing);
    const [deleteConfOpen, setDeleteConfOpen] = useState(false);
    const [emptyName, setEmptyName] = useState(false);
    const [emptyRate_1_3_days, setEmptyRate_1_3_days] = useState(false);
    const [emptyRate_4_7_days, setEmptyRate_4_7_days] = useState(false);
    const [emtyRatePerHour, setEmptyRatePerHour] = useState(false);
    const [emptyRateAboveLimit, setEmptyRateAboveLimit] = useState(false);
    const [emptyRateAbove7Days, setEmptyRateAbove7Days] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        state.nazwa ? setEmptyName(false) : setEmptyName(true);
    }, [state.nazwa]);

    useEffect(() => {
        state.stawka_1_3dni ? setEmptyRate_1_3_days(false) : setEmptyRate_1_3_days(true);
    }, [state.stawka_1_3dni]);

    useEffect(() => {
        state.stawka_4_7dni ? setEmptyRate_4_7_days(false) : setEmptyRate_4_7_days(true);
    }, [state.stawka_4_7dni]);

    useEffect(() => {
        state.stawka_godzinna ? setEmptyRatePerHour(false) : setEmptyRatePerHour(true);
    }, [state.stawka_godzinna]);

    useEffect(() => {
        state.stawka_pow_limit ? setEmptyRateAboveLimit(false) : setEmptyRateAboveLimit(true);
    }, [state.stawka_pow_limit]);

    useEffect(() => {
        state.stawka_tygodniowa ? setEmptyRateAbove7Days(false) : setEmptyRateAbove7Days(true);
    }, [state.stawka_tygodniowa]);

    const handleClose = () => {
        setShowWarning(false);
        onClose(initialPricing);
    };

    const handleSubmit = () => {
        if (!emptyName && !emptyRate_1_3_days && !emptyRate_4_7_days && !emtyRatePerHour && !emptyRateAboveLimit &&
            !emptyRateAbove7Days) {

            setShowWarning(false);

            if (isEdit) {
                onEdit(state, initialPricing);
            } else {
                onSubmit(state, initialPricing);
            }
        } else {
            setShowWarning(true);
        }
    };

    useEffect(() => {
        if (!singlePricing)
            return;
        setState(singlePricing);
    }, [singlePricing]);

    const handleChange = e => {
        e.persist();
        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    };

    const handlePricingDelete = (id) => {
        setDeleteConfOpen(false);
        onPricingDelete(id, initialPricing);
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                Cennik
            </DialogTitle>
            <DialogContent>
                <div className={classes.row}>
                    <TextField
                        className={classes.textfield}
                        label={t.name}
                        value={state.nazwa}
                        name="nazwa"
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        className={classes.textfield}
                        type="number"
                        label={t.ratePerKilometerAboveLimit}
                        value={state.stawka_pow_limit}
                        name="stawka_pow_limit"
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className={classes.row}>
                    <TextField
                        className={classes.textfield}
                        type="number"
                        label={t.perHour}
                        value={state.stawka_godzinna}
                        name="stawka_godzinna"
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        className={classes.textfield}
                        type="number"
                        label={t.from1To3Days}
                        value={state.stawka_1_3dni}
                        name="stawka_1_3dni"
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className={classes.row}>
                    <TextField
                        className={classes.textfield}
                        type="number"
                        label={t.from4to7Days}
                        value={state.stawka_4_7dni}
                        name="stawka_4_7dni"
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        className={classes.textfield}
                        type="number"
                        label={t.above7Days}
                        value={state.stawka_tygodniowa}
                        name="stawka_tygodniowa"
                        onChange={handleChange}
                        required
                    />
                </div>

                <Typography
                    variant="body1"
                    className={classes.requiredFields}
                    style={{ display: showWarning ? "block" : "none" }}
                >
                    *{t.reqiredFieldsNotFilled}
                </Typography>

            </DialogContent>
            <DialogActions>
                {isEdit &&
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setDeleteConfOpen(true)}
                    >
                        {t.deletePricing}
                    </Button>
                }
                <CancelAcceptForm
                    onCancel={handleClose}
                    onSubmit={handleSubmit} />
            </DialogActions>

            <ConfirmationDialog
                open={deleteConfOpen}
                onClose={() => setDeleteConfOpen(false)}
                action={t.deleteThisPricing}
                onSubmit={handlePricingDelete}
                id={state.cennik_id}
            />
        </Dialog>
    );
};

PricingDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    singlePricing: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    onEdit: PropTypes.func,
    onPricingDelete: PropTypes.func,
    isEdit: PropTypes.bool
};

export default withStyles(useStyles)(PricingDialog);
